import type { DescriptionsProperties } from '../../../descriptions';
import type { ErrorReport } from '../../types';
import { CodeBlock } from '../code-block';

type P = {
  request: ErrorReport['request'];
};

export const useGetRequestItems = ({ request }: P) => {
  if (!request) {
    return [];
  }

  const items: DescriptionsProperties['items'] = [
    {
      children: `${request.method?.toUpperCase() ?? ''} ${request.url ?? ''}`,
      key: 'address',
      label: 'Address',
    },
  ];

  if (request.params) {
    items.push({ children: <CodeBlock value={request.params} />, key: 'parameters', label: 'Parameters' });
  }

  if (request.data) {
    items.push({ children: <CodeBlock value={request.data} />, key: 'sent-data', label: 'Sent data' });
  }

  return items;
};
